import { FullStoryAPI } from '@zapier/react-fullstory';
export const emitFullStoryEvent = (properties) => {
    FullStoryAPI('event', properties.interaction_name, properties);
};
//# sourceMappingURL=fullStoryEvents.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
